import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/stores";

Vue.use(VueRouter);

const routes = [
    {
        name: "login",
        path: "/login",
        component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/public/login.vue"),
    },
    {
        name: "findPass",
        path: "/findPass",
        component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/public/findPass.vue"),
    },
    {
        name: "",
        path: "/",
        redirect: "/orders",
        component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/layout/index.vue"),
        children: [
            {
                name: "branchs",
                path: "/branchs",
                component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/branch/index.vue"),
            },
            {
                name: "services",
                path: "/services",
                component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/service/index.vue"),
            },
            {
                name: "banner",
                path: "/banner",
                component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/banner/index.vue"),
            },
            {
                name: "workers",
                path: "/workers",
                component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/worker/index.vue"),
            },
            {
                name: "orders",
                path: "/orders",
                component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/order/index.vue"),
            },
            {
                name: "Withdrawal",
                path: "/Withdrawal",
                component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/Withdrawal/index.vue"),
                // component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/order/index.vue"),
            },
            {
                name: "WithdrawalInfo",
                path: "/WithdrawalInfo",
                component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/Withdrawal/info.vue"),
                // component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/order/index.vue"),
            },
            {
                name: "users",
                path: "/users",
                component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/user/index.vue"),
                // component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/order/index.vue"),
            },
        ],
    },
    {
        path: "*",
        name: "404",
        component: () => import(/* webpackChunkName: 'dynamic' */ "@/views/common/404.vue"),
    },
];

const router = new VueRouter({
    routes,
    mode: "hash",
    scrollBehavior: () => ({ y: 0 }),
});

router.beforeEach(async (to, from, next) => {
    if (store.state.auth.AUTH_INFO) {
        if (to.path === "/login") {
            next({ path: "/" });
        } else {
            next();
        }
    } else {
        if (to.path === "/login" || to.path === "/other" || to.path === "/findPass"  ) {
            next();
        } else {
            next({ path: "/login" });
        }
    }
});

export default router;
